<template>
    <v-card :title="title" >
        <template slot="extra" v-if="moreUrl">
            <a :href="moreUrl" style="color: #eef0f1">MORE+</a>
        </template>
        <div style="padding-top:60px;">
            <Row>
                <Col :span="8" style="text-align: right">
                    <router-link :to="{path:toJoinThem('加入我们')}">
                        <img style="width: 85%" :src="require('@/assets/jrwm.jpg')"/>
                    </router-link>
                </Col>
                <Col :span="8" style="text-align: center">
                    <router-link :to="{path:toJoinThem('政策宣贯')}">
                        <img style="width: 85%" :src="require('@/assets/zcxg.jpg')"/>
                    </router-link>
                </Col>
                <Col :span="8">
                    <router-link :to="{path:toJoinThem('备案指引')}">
                        <img style="width: 85%" :src="require('@/assets/bazy.jpg')"/>
                    </router-link>
                </Col>
            </Row>
            <Row style="margin-top: 15px">
                <Col style="text-align: right" :span="8">
                    <router-link :to="{path:toJoinThem('培训服务')}">
                        <img style="width: 85%" :src="require('@/assets/pxfw.jpg')"/>
                    </router-link>
                </Col>
                <Col style="text-align: center" :span="8">
                    <router-link :to="{path:toJoinThem('资讯分享')}">
                        <img style="width: 85%" :src="require('@/assets/zxfx.jpg')"/>
                    </router-link>
                </Col>
                <Col  :span="8">
                    <router-link :to="{path:toJoinThem('人才交流')}">
                        <img style="width: 85%" :src="require('@/assets/rcjl.jpg')"/>
                    </router-link>
                </Col>
            </Row>
        </div>
    </v-card>
</template>

<script>
    import VCard from "./Card";
    import {mapGetters} from 'vuex'

    export default {
        name: "vImageOtherCard",
        props:['title','list','moreUrl','height'],
        computed:{
            styleFormat(){
                return {
                    height:(this.height - 60) + 'px'
                }
            },
            ...mapGetters('channel',{'channels':'tree'})
        },
        components:{VCard},
        methods:{
            /**
             * 加入我们（遍历所有目录，跳转到第一个‘加入我们’的链接）
             */
            toJoinThem(title){
                var id = 0;
                var flag = true;
                console.log(Object.values(this.channels))
                Object.values(this.channels).forEach((item)=>{
                    if(item.name === title && flag){
                        id = item.id;
                        flag = false;
                    }else {
                        if(item.children !== null && item.children !== undefined){
                            item.children.forEach((value)=>{
                                if(value.name === title && flag){
                                    id = value.id;
                                    flag = false;
                                }
                            });
                        }
                    }
                });
                return '/channel/' + id;
            },
        }
    }
</script>

<style lang="less" scoped>
    @import "../pages/common/mui";
    .image-item{
        display: block;
        position: relative;
        text-align: center;
        & > img{
            max-width: 100%;
            height: 100%;
            margin: 0 auto;
        }
    }

</style>